import {getMomentDate} from '../utils/commonUtils';

export default class Role {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(data = {}) {
        this.id = data.id || undefined;
        this.name = data.name || undefined;
        this.permissions = data.permissions || [];
        this.createdDate = getMomentDate(data.createdDate);
        this.modifiedDate = getMomentDate(data.modifiedDate);
    }

    export() {
        return {
            id: this.id,
            name: this.name,
            permissions: this.permissions,
            createdDate: this.createdDate && this.createdDate.toISOString(),
            modifiedDate: this.modifiedDate && this.modifiedDate.toISOString(),
        }
    }
}